import React from "react";

import AppHangFreeSessionsAboutView from "@main/pages/Release/views/MetricDetails/AppHangFreeSessions/AppHangFreeSessionsAboutView";
import CrashFreeSessionsAboutView from "@main/pages/Release/views/MetricDetails/CrashFreeSessions/CrashFreeSessionsAboutView";
import EndpointHealthAboutView from "@main/pages/Release/views/MetricDetails/EndpointHealth/EndpointHealthAboutView";
import MttrAboutView from "@main/pages/Release/views/MetricDetails/Mttr/MttrAboutView";
import NetworkSpeedAboutView from "@main/pages/Release/views/MetricDetails/NetworkSpeed/NetworkSpeedAboutView";
import ReleaseHealthAboutView from "@main/pages/Release/views/MetricDetails/ReleaseHealth/ReleaseHealthAboutView";
import ResolutionRateAboutView from "@main/pages/Release/views/MetricDetails/ResolutionRate/ResolutionRateAboutView";
import TestingCoverageAboutView from "@main/pages/Release/views/MetricDetails/TestingCoverage/TestingCoverageAboutView";
import { MetricKeys } from "@main/router/config/routePaths";
import { useParams } from "react-router-dom";

export default function MetricAboutView() {
  const { metricKey } = useParams<{ metricKey: string }>();

  if (metricKey === MetricKeys.testingCoverage) return <TestingCoverageAboutView />;
  if (metricKey === MetricKeys.releaseHealth) return <ReleaseHealthAboutView />;
  if (metricKey === MetricKeys.crashFreeSessions) return <CrashFreeSessionsAboutView />;
  if (metricKey === MetricKeys.appHangFreeSessions) return <AppHangFreeSessionsAboutView />;
  if (metricKey === MetricKeys.resolutionRate) return <ResolutionRateAboutView />;
  if (metricKey === MetricKeys.mttr) return <MttrAboutView />;
  if (metricKey === MetricKeys.endpointHealth) return <EndpointHealthAboutView />;
  if (metricKey === MetricKeys.networkSpeed) return <NetworkSpeedAboutView />;

  return <></>;
}
